import { render, staticRenderFns } from "./neirong.vue?vue&type=template&id=50fe7554&"
import script from "./neirong.vue?vue&type=script&lang=ts&"
export * from "./neirong.vue?vue&type=script&lang=ts&"
import style0 from "./neirong.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports